import React, { useState, useEffect } from 'react';

const links = [
  ['galeria', 'Galería'],
  ['sobre-mi', 'Sobre mí'],
  ['contacto', 'Contacto'],
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const to = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <header
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${
        scrolled ? 'bg-paper/90 backdrop-blur border-b border-line' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1500px] mx-auto px-4 sm:px-6 md:px-10 h-14 md:h-16 flex items-center justify-between gap-3">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="font-display font-semibold tracking-[0.12em] sm:tracking-[0.2em] text-[11px] sm:text-[12px] md:text-[13px] whitespace-nowrap"
        >
          SEBASTIAN CHUFFER
        </button>
        <nav className="flex items-center gap-3.5 sm:gap-5 md:gap-8 shrink-0">
          {links.map(([id, label]) => (
            <button
              key={id}
              onClick={() => to(id)}
              className="text-[10px] sm:text-[11px] md:text-[12px] tracking-[0.1em] sm:tracking-[0.16em] uppercase text-muted hover:text-ink transition-colors py-2"
            >
              {label}
            </button>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Header;
